<template>
  <vue-final-modal
    :value="value"
    :name="name"
    :classes="['new-rirekisho-example-sentence-dialog__container']"
    :content-class="[
      'new-rirekisho-example-sentence-dialog__content',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="$emit('input', $event)"
    @opened="onOpened"
  >
    <div class="v--modal-close-top">
      <el-button
        icon="el-icon-close"
        type="text"
        @click="$emit('input', false)"
      />
    </div>
    <div class="title">例文を選ぶ</div>
    <div class="description">
      <p>選択した例文が追加されます。</p>
      <p v-if="showOverwriteWarning" class="attention">
        {{ overwriteWarning }}
      </p>
    </div>
    <ul class="example-sentence">
      <li v-for="(item, index) in items" :key="index" @click="onSelect(item)">
        <div class="title">{{ item.title }}</div>
        <div class="body" v-html="item.description"></div>
      </li>
    </ul>
    <div class="text-right">
      <el-button @click="$emit('input', false)">閉じる</el-button>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { nextTick } from 'vue'
import type { NewRirekishoExampleSentence } from '@/composables/format-edit/useNewRirekishoFormatData'

withDefaults(
  defineProps<{
    value: boolean
    name: string
    items: NewRirekishoExampleSentence[]
    showOverwriteWarning?: boolean
    overwriteWarning?: string
  }>(),
  {
    showOverwriteWarning: false,
    overwriteWarning:
      '例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。'
  }
)

const emit = defineEmits<{
  (e: 'input', value: boolean): void
  (e: 'select', item: NewRirekishoExampleSentence): void
}>()

function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.new-rirekisho-example-sentence-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onSelect(item: NewRirekishoExampleSentence) {
  emit('select', item)
  emit('input', false)
}
</script>

<!--
  旧 vue-js-modal: adaptive + scrollable + height="auto"（width 未指定 = 600px）。
  Pattern A: :styles flex 禁止。配置・スクロールは __container。
  attach=body 時の absolute を fixed 化（ページ縦スクロール位置に依存しない）。
-->
<style lang="scss">
@import '@/assets/scss/format-edit/vfm-attach-body-fixed';
@include vfm-root-fixed-when-has(
  '.new-rirekisho-example-sentence-dialog__container'
);

.new-rirekisho-example-sentence-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.new-rirekisho-example-sentence-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 1 auto;
  width: 600px;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 20px 20px 50px;
  left: 0 !important;
}

.new-rirekisho-example-sentence-dialog__content .title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.75rem;
}

.new-rirekisho-example-sentence-dialog__content .v--modal-close-top {
  text-align: right;
}

.new-rirekisho-example-sentence-dialog__content .description .attention {
  color: #e3165c;
}
</style>
